import {
  Box,
  Divider,
  Drawer,
  Icon,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { theme } from "../../config/theme";
import { useLocation, useNavigate } from "react-router";
import CoreTypographySubtitle2 from "../dataDisplay/CoreTypographySubtitle2";
import CoreTypographyBody1 from "../dataDisplay/CoreTypographyBody1";
import CoreTypographyCaption from "../dataDisplay/CoreTypographyCaption";
import moment from "moment";
import { drawerWidth } from "../../config/constants";

export default function SideBar({ open }) {
  const navigate = useNavigate();
  const location = useLocation();

  const rolePermission = useSelector(
    (state) => state?.rolePermission?.rolePermission,
  );
  const basicDetails = useSelector((state) => state?.profile?.basic);
  const clientInfo = useSelector((state) => state?.auth?.clientInfo);

  const onNav = (option) => {
    // console.log("option", option);
    navigate(option.link);
  };

  return (
    <Drawer
      component="nav"
      variant="persistent"
      open={open}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        display: open ? { xs: "flex" } : { xs: "none", sm: "flex" },
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          top: "64px",
        },
      }}
    >
      <Box style={{ maxHeight: "75vh", minHeight: "75vh", overflowY: "auto" }}>
        {/* <Divider /> */}
        {rolePermission && (
          <List>
            {rolePermission?.permissions?.map((permission, index) => (
              <>
                <ListItem
                  style={
                    location?.pathname === permission.link
                      ? {
                          color: theme?.palette?.primary?.dark,
                          backgroundColor: theme?.palette?.secondary?.light,
                          paddingBottom: 0,
                          paddingTop: 0,
                          cursor: "pointer",
                        }
                      : {
                          color: theme?.palette?.primary?.dark,
                          paddingBottom: 0,
                          paddingTop: 0,
                          cursor: "pointer",
                        }
                  }
                  key={permission.label}
                  onClick={() => {
                    onNav(permission);
                  }}
                >
                  <Icon>{permission?.icon}</Icon>
                  <ListItemText
                    style={{ marginLeft: 8 }}
                    primary={permission.label}
                  />
                </ListItem>
                {permission?.Children?.map((childPers, childIndex) => (
                  <ListItem
                    style={
                      location?.pathname === childPers.link
                        ? {
                            color: theme?.palette?.primary?.dark,
                            backgroundColor: theme?.palette?.secondary?.light,
                            cursor: "pointer",
                            paddingBottom: 0,
                            paddingTop: 0,
                          }
                        : {
                            color: theme?.palette?.primary?.dark,
                            cursor: "pointer",
                            paddingBottom: 0,
                            paddingTop: 0,
                          }
                    }
                    key={childPers.label}
                    onClick={() => {
                      onNav(childPers);
                    }}
                  >
                    <Icon style={{ marginLeft: 32 }}>{childPers?.icon}</Icon>
                    <ListItemText
                      style={{ marginLeft: 16 }}
                      primary={childPers.label}
                    />
                  </ListItem>
                ))}
              </>
            ))}
          </List>
        )}
      </Box>
      <Divider />
      <Box style={{ textAlign: "right", padding: 16, height: "20vh" }}>
        <CoreTypographySubtitle2>
          Welcome{" "}
          {basicDetails?.firstName && basicDetails?.firstName.length > 0
            ? basicDetails?.firstName + ", "
            : "User,"}
        </CoreTypographySubtitle2>
        <CoreTypographyBody1 style={{ fontSize: "0.8rem" }}>
          you can upload up to <strong>{basicDetails?.remainingInvoice}</strong>{" "}
          documents
        </CoreTypographyBody1>
        <CoreTypographyCaption
          style={{ textAlign: "left", position: "fixed", bottom: 0 }}
        >
          Last login:{" "}
          {moment(clientInfo?.lastLoginDetail?.createdAt).format(
            "YYYY-MM-DD, hh:mm",
          )}
        </CoreTypographyCaption>
      </Box>
    </Drawer>
  );
}
